import client from './RestClient';
import { L1ObjectChannel } from 'core/l1Object/L1Object';
import { AxiosInstance } from 'axios';

export type BindingCreateRequest = {
  l2ChannelIds?: string[];
  l3ChannelIds?: string[];
  goCreativeIds: string[];
  active: boolean;
  draft: boolean;
}[];

export interface BindingWebService {
  createBinding(
    channel: string,
    channelGroupId: number | undefined,
    createRequest: BindingCreateRequest
  ): Promise<void>;
  updateBinding(
    channel: string,
    channelGroupId: number | undefined,
    updateRequest: BindingCreateRequest
  ): Promise<void>;
}

export class RestfulBindingWebService implements BindingWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async createBinding(
    channel: string,
    channelGroupId: number | undefined,
    createRequest: BindingCreateRequest
  ): Promise<void> {
    let apiPath = `/v2/l3-object/${channel}/create`;
    if (!L1ObjectChannel[channel]) {
      apiPath = `/v2/l3-object/create?channel_id=${channelGroupId}`;
    }
    return this.restClient.post(apiPath, createRequest);
  }

  async updateBinding(
    channel: string,
    channelGroupId: number | undefined,
    updateRequest: BindingCreateRequest
  ): Promise<void> {
    let apiPath = `/v2/l3-object/${channel}/update`;
    if (!L1ObjectChannel[channel]) {
      apiPath = `/v2/l3-object/update?channel_id=${channelGroupId}`;
    }
    return this.restClient.put(apiPath, updateRequest);
  }
}
